import {ApiClient} from '@hconnect/apiclient'
import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {TasksApiPath, FEATURE_NAMESPACE} from '../../../consts'
import {CreateOilAnalysisMaintenanceNotificationActionDto} from '../../../types'

export const OilAnalysisActionQueryKey = 'oil-analysis-action'

type Params = {
  plantUpmId?: string
  externalId: string
}

export const useCreateOilAnalysisActionMaintenanceNotification = (
  {plantUpmId, externalId}: Params,
  options?: UseMutationOptions<
    string,
    AxiosError,
    CreateOilAnalysisMaintenanceNotificationActionDto
  >
) => {
  const queryClient = useQueryClient()
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const path = `${TasksApiPath.OIL_ANALYSIS_ACTIONS}/${plantUpmId}/oil-analysis-actions/${externalId}/maintenance-notification`

  return useMutation<string, AxiosError, CreateOilAnalysisMaintenanceNotificationActionDto>({
    mutationKey: [OilAnalysisActionQueryKey, externalId, plantUpmId],
    ...options,
    mutationFn: async (data) => {
      const response = await ApiClient.axiosInstance.post<string>(path, {
        sourceEventId: externalId,
        ...data
      })
      return response.data
    },
    onError: (...args) => {
      spawnErrorToast(t('oilAnalysisActions.message.failedToCreateMaintenanceNotification'))
      options?.onError?.(...args)
    },
    onSuccess: async (...args) => {
      spawnSuccessToast(t('oilAnalysisActions.message.maintenanceNotificationCreated'))
      await queryClient.invalidateQueries({
        queryKey: [OilAnalysisActionQueryKey],
        refetchType: 'all'
      })
      options?.onSuccess?.(...args)
    }
  })
}
